import { CookieBlockProps } from './cookieBlock.state'
import { DP } from '../../../drupal/blockDefinitions'

export const drupal = (dpBlock: DP.CookieBlock, blockIndex: number): CookieBlockProps | undefined => {

  const target = dpBlock.target.type[0].target_id
  if (target != 'cookies') return undefined

  return {
    title: dpBlock.target.field_title[0]?.value ? dpBlock.target.field_title[0]?.value : undefined,
    excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value ? dpBlock.target?.field_exclude_from_page_menu?.[0].value : undefined,
    text: dpBlock.target.field_body[0]?.value ? dpBlock.target.field_body[0]?.value : undefined,
    label: dpBlock.target.field_label[0]?.value ? dpBlock.target.field_label[0]?.value : undefined,
    intro: dpBlock.target.field_introduction[0]?.value ? dpBlock.target.field_introduction[0]?.value : undefined,
    anchorTitle: dpBlock.target.field_title[0]?.value ? dpBlock.target.field_title[0]?.value : "",
    inviewState: false
  }
}
